<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.purchase_management')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('payment.archive_account_payable')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
        <div class="form-inline">
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <v-select
              :value="master_clients.find(m => m.id === partner_id) || ''"
              :options="master_clients"
              label="name"
              :placeholder="translations('payment.supplier')"
              id="partner_id"
              @input="changedPartner">
            </v-select>
          </div>
          <div class="form-group mr-3 d-flex align-items-center">
            <span class="text-nowrap mr-1">{{translations('payment.date')}}</span>
<!--            <input v-model="aggregatedAt" type="date" class="form-control" @blur='triggerDateFilter()' @focus='tempDateField = aggregatedAt'>-->
            <input v-model="aggregatedAt" type="date" class="form-control">
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
        <p class="mb-0">{{translations('payment.total_accounts_payable')}}：<span id="payable-sum" class="font-weight-bold">{{ totalCalc.toLocaleString() }}</span></p>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-800"
          item-key="name"
          :headers="[
            { text: this.translations('payment.name'), value: 'base_date' },
            { text: this.translations('payment.payment_destination'), value: 'partner_name' },
            { text: this.translations('payment.accounts_payable_previous'), value: 'previous_accounts_payable' },
            { text: this.translations('payment.current_accounts_payable'), value: 'accounts_payable' },
            { text: this.translations('payment.withdrawal_amount_this_time'), value: 'payment' },
            { text: this.translations('payment.accounts_payable_balance'), value: 'total_accounts_payable' },
          ]"
          :items="payable"
          hide-default-footer
          :options.sync="options"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
          <tbody class="nowrap">
            <template v-if="!isEmpty">
            <tr v-for="(item, i) in items" :key='i' data-href="">
              <td>{{ $invoiceTools.formatDate(item.base_date + '') }}</td>
              <td>{{ item.partner_name }}</td>
              <td class="right">{{ $invoiceTools.moneyDelimiter(item.previous_accounts_payable) }}</td>
              <td class="right">{{ $invoiceTools.moneyDelimiter(item.accounts_payable) }}</td>
              <td class="right">{{ $invoiceTools.moneyDelimiter(item.payment) }}</td>
              <td class="right">{{ $invoiceTools.moneyDelimiter(item.total_accounts_payable) }}</td>
            </tr>
            </template>
            <template v-else>
              <tr class="odd">
                <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
              </tr>
            </template>
          </tbody>
          </template>
        </v-data-table>
      </div>
      <ArchiveDatatablePagination :pageCount="pageCount" :page.sync="page" @changePage="page=$event"/>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import ArchiveDatatablePagination from '@/components/ArchiveDatatablePagination'
import { mapState } from 'vuex'

export default {
  name: 'ArchiveAccountsPayable',
  props: {},
  components: {
    VueElementLoading,
    ArchiveDatatablePagination
  },
  computed: {
    ...mapState(['currentLanguage']),
    master_clients () {
      return this.$store.getters['Master/getPayTo']
    },
    totalCalc () {
      let total = this.payable.reduce((prev, current) => {
        return prev + current.total_accounts_payable
      }, 0)
      return total
    }
  },
  watch: {
    dtSearch (v) {
      this.$storage.set('ArchiveAccountsPayable:dtSearch', v) // KEEP KEYWORD
    },

    options: {
      handler: function (val, oldVal) {
        let sortParams = {
          sortBy: val.sortBy,
          sortDesc: val.sortDesc
        }

        this.$storage.set('ArchiveAccountsReceivableSortParam', sortParams)
      },
      deep: true
    }
  },
  data () {
    return {
      dtSearch: this.$storage.get('ArchiveAccountsPayable:dtSearch') || '',
      isLoading: false,
      isSearching: false,
      partner_id: 0,
      aggregatedAt: this.$invoiceTools.getCurrentFormatDate(),
      payable: [],
      isEmpty: false,
      isEmptyMsg: '',
      tempDateField: '',
      page: 1,
      pageCount: null,
      itemsPerPage: 10,
      options: {
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      }
    }
  },
  created: async function () {
    this.isSearching = true
    this.$store.dispatch('Master/checkPayTo')
    this.$storage.set('ArchiveAccountsPayableParam:aggregated_at', this.aggregatedAt)
    let storedFilter = this.$storage.get('ArchiveAccountsPayableParam')
    const sortParams = this.$storage.get('ArchiveAccountsReceivableSortParam')

    if (sortParams) {
      this.options.sortBy = sortParams.sortBy
      this.options.sortDesc = sortParams.sortDesc
    }
    if (storedFilter) {
      this.partner_id = storedFilter.partner_id ? parseInt(storedFilter.partner_id) : 0
      this.aggregatedAt = storedFilter.aggregated_at
    }

    const self = this
    Promise.all([
      this.listAccountsPayable()
    ]).then(function () {
      self.isSearching = false
    }).catch(function (error) {
      self.$toastr.error(error, 'エラー')
    })
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    listAccountsPayable () {
      const params = {
        partner_id: this.partner_id,
        aggregated_at: this.aggregatedAt
      }

      const self = this
      return this.$http.post(this.$api_url.payable_list, params).then(function (response) {
        const result = response.data
        if (result.status === true) {
          self.payable = result.list
          return Promise.resolve()
        } else {
          self.payable = []
          return Promise.resolve()
        }
      }).catch(function (error) {
        console.log('ArchiveAccountsPayable:listAccountsPayable:catch(error): ', error)
        return Promise.reject(new Error('1エラーのため失敗しました。ご確認後、再試行してください。'))
      })
    },

    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    async triggerFilter (field, val) {
      try {
        if (!this.aggregatedAt) {
          this.$toastr.warning('日付を選択してください。', '')
          return
        }

        this.isSearching = true

        let params = {
          partner_id: this.partner_id,
          aggregated_at: this.aggregatedAt,
          search: this.dtSearch
        }
        this.$storage.set('ArchiveAccountsPayableParam', params)
        console.log('ArchiveAccountsPayable:triggerFilter: ', params)

        try {
          let filteredPayableList = await this.$http.post(this.$api_url.payable_list, params)
          let $data = this.$invoiceTools.prepareResult(filteredPayableList.data, 'list', 'ArchiveAccountsPayable:listAccountsPayable')
          if ($data.success === true) {
            this.isEmpty = false
            this.isEmptyMsg = ''
            this.payable = $data.data
          } else {
            this.payable = []
          }
        } catch (error) {
          console.log('ArchiveAccountsPayable:listAccountsPayable:catch(error): ', error)
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
        this.isSearching = false
      } catch (e) {
        this.isEmpty = true
        this.isEmptyMsg = 'エラーのため失敗しました。ご確認後、再試行してください。'
        this.isSearching = false
        console.log('ArchiveAccountsPayable:API:triggerFilter: error: ', e)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    // triggerDateFilter (source) {
    //   if (!this.aggregatedAt) {
    //     this.$toastr.warning('日付を選択してください。', '')
    //     return
    //   }
    //   if (this.aggregatedAt !== this.tempDateField) {
    //     this.triggerFilter()
    //   }
    // },

    changedPartner (event) {
      if (!event) {
        this.partner_id = 0
        return
      }
      this.partner_id = event.id
    },
    submitSearch () {
      this.triggerFilter()
    }
  }
}
</script>

<style>
#tbl-accounts-payable_wrapper .col-sm-12{
  padding-right: 0 !important;
}
</style>
